"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
exports.__esModule = true;
exports.DataTransformers = void 0;
var ui_common_1 = require("@codametrix/ui-common");
var onlyUnique = function (value, index, self) {
    return self.indexOf(value) === index;
};
/**
 * DataTransformers take two objects.  A property accessor and the raw case run.
 * The raw case run is a fall back mechanism for array access which doesn't
 * currently have a method of highlighting.
 * @param propAccessor
 * @param rawCaseRun
 * @returns
 */
var DataTransformers = function (propAccessor, rawCaseRun, activeContext) {
    return {
        friendly_date: function (key) {
            var date_of_birth = rawCaseRun.date_of_birth;
            return date_of_birth && date_of_birth !== 'N/A'
                ? ui_common_1.cmxDateTime.format(date_of_birth, ui_common_1.cmxDateTime.FORMATS.BIRTH_DATE)
                : 'N/A';
        },
        date_of_service: function (key) {
            var date = propAccessor(key);
            return date && typeof date === 'string' && date !== 'N/A'
                ? ui_common_1.cmxDateTime.format(ui_common_1.cmxDateTime.setTimeZoneForDate(rawCaseRun === null || rawCaseRun === void 0 ? void 0 : rawCaseRun.tenant_timezone, date), ui_common_1.cmxDateTime.FORMATS.DATE_OF_SERVICE)
                : 'N/A';
        },
        mrn: function (key) {
            var numberProp = "".concat(key, ".number");
            var sourceProp = "".concat(key, ".issuer");
            return "".concat(propAccessor(numberProp), " (src: ").concat(propAccessor(sourceProp), ")");
        },
        numerical: function (key) {
            return propAccessor("".concat(key, ".number"));
        },
        multi_place_of_service: function (key) {
            // to be unignored when caserun2 is implemented in omnibus.
            //@ts-ignore
            var invoices = (rawCaseRun === null || rawCaseRun === void 0 ? void 0 : rawCaseRun.invoices) || [];
            var place_of_service = invoices.map(function (invoice) { return invoice.place_of_service; });
            var uniq_pos = place_of_service.filter(function (pos) { return pos; }).filter(onlyUnique);
            return uniq_pos.length
                ? uniq_pos.join(', ')
                : rawCaseRun.place_of_service || 'N/A';
        },
        specimen_sources: function (key) {
            // @ts-ignore
            var specimen_sources = rawCaseRun.specimen_sources;
            if (!Array.isArray(specimen_sources)) {
                return specimen_sources;
            }
            else {
                var _a = __read(specimen_sources, 1), first = _a[0];
                if (first === undefined) {
                    return 'N/A';
                }
                return first;
            }
        },
        identifier: function (key) {
            var numberProp = "".concat(key, ".number");
            var sourceProp = "".concat(key, ".issuer");
            return "".concat(propAccessor(numberProp), " (src: ").concat(propAccessor(sourceProp), ")");
        },
        service_line: function (key) {
            var serviceLine = propAccessor(key);
            var mappedServiceLine = ui_common_1.appServiceLines.isIPC(serviceLine)
                ? ui_common_1.commonEnums.ServiceLines.BEDSIDE_PRO
                : serviceLine;
            if (activeContext) {
                var serviceLines = activeContext.serviceLines;
                var currentServiceLine = serviceLines.find(function (sl) {
                    return sl.name === mappedServiceLine;
                });
                if (currentServiceLine) {
                    return currentServiceLine.displayName || currentServiceLine.name;
                }
            }
            return ui_common_1.appServiceLines.isIPC(serviceLine)
                ? ui_common_1.commonEnums.ServiceLines.BEDSIDE_PRO
                : serviceLine;
        },
        age: function (key) {
            var date_of_birth = rawCaseRun.date_of_birth;
            if (!date_of_birth || date_of_birth === 'N/A') {
                return 'N/A';
            }
            var birthDate = new Date(date_of_birth);
            var currentDate = new Date();
            var age = currentDate.getFullYear() - birthDate.getFullYear();
            var m = currentDate.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && currentDate.getDate() < birthDate.getDate())) {
                age--;
            }
            return age.toString();
        },
        patient_age_by_dos_dob: function (key) {
            var patientAge = rawCaseRun.patient_age;
            if (!patientAge) {
                var dob = rawCaseRun.date_of_birth;
                var dos = rawCaseRun.date_of_service;
                if (dob && dos) {
                    var dobDate = new Date(dob);
                    var dosDate = new Date(dos);
                    var age = dosDate.getFullYear() - dobDate.getFullYear();
                    var m = dosDate.getMonth() - dobDate.getMonth();
                    if (m < 0 || (m === 0 && dosDate.getDate() < dobDate.getDate())) {
                        return age - 1;
                    }
                    else {
                        return age;
                    }
                }
            }
        },
        age_on_date_of_service: function (key) {
            var date_of_birth = rawCaseRun.date_of_birth;
            var date_of_service = rawCaseRun.date_of_service;
            var duration = ui_common_1.cmxDateTime.calculateDurationDateFns(date_of_birth, date_of_service);
            // conditional for bad data: negative time values occur when DOB is after DOS
            if (!duration || new Date(date_of_birth) > new Date(date_of_service)) {
                return 'N/A';
            }
            if (duration.years && duration.years > 0) {
                return "".concat(duration.years);
            }
            return "".concat(duration.months || 0, " months, ").concat(duration.days || 0, " days");
        }
    };
};
exports.DataTransformers = DataTransformers;
//# sourceMappingURL=encounter-data.transformers.js.map